import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Checkbox } from 'elmo-elements';

import { ScrollbarIndicator } from '@/lib/util';

import ChoiceOption from '@/components/ChoiceOption';
import { ChoiceOptionType } from '@/modules/types/choice';

import './MultiChoice.scss';

const MultiChoice = ({
  choices,
  isDisabled,
  handler,
}: {
  choices: ChoiceOptionType[];
  isDisabled: boolean;
  handler: (answer: string) => void;
}): ReactElement => {
  const [choiceList, setChoiceList] = useState<ChoiceOptionType[]>(choices);
  const [clickCount, setClickCount] = useState(0);
  const [answer, setAnswer] = useState(new Set());
  const [showButtonGroup, setShowButtonGroup] = useState(false);

  const getSelectedId = (choice: ChoiceOptionType) =>
    choice.data.choiceMetadata?.useUUID || !choice.data.lcmsReferenceIds
      ? choice.data.id
      : `${choice.data.lcmsReferenceIds.id}`;

  const selectChoice = (choice: ChoiceOptionType) => {
    const selectedChoice = getSelectedId(choice);
    const result = answer;
    if (answer.has(selectedChoice)) {
      result.delete(selectedChoice);
    } else {
      result.add(selectedChoice);
    }
    setAnswer(result);
    setClickCount((prev) => prev + 1);
  };

  const resetHandler = () => {
    setAnswer(new Set());
    setClickCount(0);
  };

  const submitHandler = () => {
    handler(Array.from(answer).join(','));
  };

  const setStatus = (item: ChoiceOptionType) => {
    item.isSelected = !!answer.has(getSelectedId(item));
  };

  useEffect(() => {
    if (choices.length > 0) {
      setChoiceList(choices);
    }
  }, [choices]);

  useEffect(() => {
    const result = [...choiceList];
    result.map((obj) => {
      setStatus(obj);
      return obj;
    });
    setChoiceList(result);
  }, [clickCount]);

  useEffect(() => {
    if (answer.size > 0) {
      setShowButtonGroup(true);
    } else {
      setShowButtonGroup(false);
    }
  }, [answer.size]);
  return (
    <div id="MultiChoice">
      <div className="multiplechoice-wrapper" ref={ScrollbarIndicator()}>
        {choiceList.map((item: ChoiceOptionType, index: number) => (
          <ChoiceOption
            key={index}
            icon={
              <Checkbox
                id={`Checkbox-${item.data.id}`}
                isChecked={item.isSelected}
              />
            }
            iconRight={false}
            title=""
            description={item.data.content}
            onClick={() => {
              selectChoice(item);
            }}
            isDisabled={isDisabled}
            className={`${item.isSelected ? 'is-selected' : ''}`}
          />
        ))}
      </div>
      {showButtonGroup && (
        <div className="btn-group">
          <Button
            type="default"
            onClick={() => {
              resetHandler();
            }}
            className="reset-btn"
          >
            Reset
          </Button>
          <Button
            type="primary"
            onClick={() => {
              submitHandler();
            }}
            className="submit-btn"
          >
            Submit
          </Button>
        </div>
      )}
    </div>
  );
};

export default MultiChoice;
